import React from 'react';
import classnames from 'classnames';
import Button from '../Button';
import CloseButton from '../Button/CloseButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import SystemNotificationIcon from './SystemNotificationIcon';
import { ReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import s from './SystemNotification.scss';
// CR44
const SystemNotification = ({ iconComponent, rootRef, customIcon, heading, className, textClassName, closeButtonClassName, iconClassName, backgroundDeviation, children, onClose, actions = [], multiLine, onMouseEnter, onMouseLeave, dataHook, withShadow = true, withCloseButton = true, limitTextWidth = true })=>{
    const filteredActions = actions.filter((a)=>!!a);
    const icon = customIcon ? customIcon : iconComponent ? /*#__PURE__*/ React.createElement(SystemNotificationIcon, {
        iconComponent: iconComponent,
        backgroundDeviation: backgroundDeviation
    }) : null;
    return /*#__PURE__*/ React.createElement("div", {
        ref: rootRef,
        className: classnames(className, s['root'], withShadow && s['shadow'], icon && s['with-icon'], limitTextWidth && s['limit-text-width']),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-hook": dataHook
    }, icon && /*#__PURE__*/ React.createElement("div", {
        className: classnames(iconClassName, s['icon'])
    }, icon), /*#__PURE__*/ React.createElement("div", {
        className: s['text-wrap']
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['text'], multiLine && s['multiline'], textClassName)
    }, children)), filteredActions.length > 0 && /*#__PURE__*/ React.createElement(ReverseTheme, {
        className: s['actions']
    }, filteredActions.map((action)=>action && /*#__PURE__*/ React.createElement(Button, {
            key: action.label,
            className: s['action'],
            view: action.type === 'positive' ? 'b3' : 'b31',
            href: action.href,
            onClick: action.closeOnClick ? ()=>{
                action.onClick && action.onClick();
                onClose();
            } : action.onClick,
            biData: action.biData
        }, action.label))), withCloseButton && /*#__PURE__*/ React.createElement(ReverseTheme, {
        className: s['close-button-wrap']
    }, /*#__PURE__*/ React.createElement(CloseButton, {
        view: "b5-2",
        iconSize: IconSize.NANO,
        className: classnames(s['close-button'], closeButtonClassName),
        onClick: (e)=>{
            e.stopPropagation();
            onClose();
        }
    })));
};
SystemNotification.displayName = 'SystemNotification';
export default SystemNotification;

//# sourceMappingURL=SystemNotification.js.map